
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Onedaytripnearwashim() {



  const cardData =
  {
    keyword: ' One Day Trip Near Washim',
    heading:  'Woodland Escape: One Day Trip Near Washim ',
    headingDescription: 'Woodland Escape Resort is the perfect destination for a one day trip near Washim, offering a relaxing escape surrounded by greenery, open lawns, and soothing forest views. Located just a short drive from the city, the resort is ideal for families, friends, and groups seeking peace and recreation in nature’s lap. Visitors can enjoy outdoor games, scenic walks, and picnic-style lunches while soaking in the fresh countryside air. With comfortable seating areas, delicious meals, and warm hospitality, Woodland Escape Resort near Washim ensures every one-day outing becomes a rejuvenating experience filled with joy, laughter, and natural beauty.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "One Day Trip Near Washim",
      "description": "Discover the best one-day trips near Washim designed for travelers seeking adventure, relaxation, and sightseeing in a single day. These trips cover cultural landmarks, natural beauty, and hidden gems easily accessible from Washim for a refreshing day out."
    },
    {
      "name": "Washim Day Tour",
      "description": "Enjoy a full-day tour in and around Washim exploring historical sites, local markets, and scenic spots. These day tours provide a mix of guided and self-exploration options, perfect for families, friends, or solo travelers looking for a memorable experience."
    },
    {
      "name": "Washim Local Sightseeing Trip",
      "description": "Explore the rich heritage and natural attractions of Washim on a local sightseeing trip. From temples and gardens to riversides and cultural spots, this trip offers an immersive experience of Washim’s vibrant culture and scenic beauty."
    },
    {
      "name": "Washim Short Excursion",
      "description": "Plan a short excursion around Washim for a quick escape from the city. These trips are ideal for half-day or single-day getaways, featuring easy travel routes, scenic landscapes, and fun activities for a stress-free outing."
    },
    {
      "name": "Affordable One Day Trip Washim",
      "description": "Experience an affordable yet fulfilling one-day trip in Washim. These options combine sightseeing, meals, and activities within a budget, making it perfect for students, families, and budget-conscious travelers without compromising on fun and comfort."
    },
    {
      "name": "Washim Nearby Attractions Trip",
      "description": "Visit Washim’s nearby attractions including riversides, hills, gardens, and cultural landmarks. This one-day trip is designed for exploration and photography, providing a perfect blend of nature, history, and leisure activities."
    },
    {
      "name": "Washim Weekend Day Trip",
      "description": "Make your weekends special with a day trip around Washim. Relax amidst nature, visit cultural landmarks, enjoy local delicacies, and spend quality time with family or friends while escaping the hustle of city life."
    },
    {
      "name": "Washim Family Day Trip",
      "description": "Plan a family-friendly day trip in Washim that caters to all age groups. With safe travel routes, engaging activities, and scenic spots, these trips ensure fun, comfort, and memorable bonding experiences for families."
    },
    {
      "name": "Washim Nature Day Trip",
      "description": "Reconnect with nature on a day trip in Washim, surrounded by rivers, hills, and lush greenery. Ideal for trekking, photography, and picnics, these trips provide a rejuvenating escape for nature lovers."
    },
    {
      "name": "Washim Riverside Trip",
      "description": "Spend a relaxing day by the riversides of Washim, enjoying serene water views, calm breezes, and opportunities for boating or leisure walks. Perfect for couples, families, and photographers seeking a peaceful day outdoors."
    },
    {
      "name": "Washim Hill One Day Tour",
      "description": "Embark on a scenic hill tour near Washim with panoramic views, cool air, and light trekking opportunities. This day trip is ideal for adventure enthusiasts and nature lovers looking for a refreshing escape from city life."
    },
    {
      "name": "Washim Excursion Packages",
      "description": "Choose from curated one-day excursion packages in Washim that include transport, meals, guided sightseeing, and recreational activities. These packages ensure a hassle-free and enjoyable experience for groups, families, or solo travelers."
    },
    {
      "name": "Washim One Day Outing",
      "description": "Plan a fun-filled one-day outing in Washim with friends or family. These trips include scenic spots, outdoor games, picnic areas, and local experiences to make your day memorable and exciting."
    },
    {
      "name": "Washim Day Trip Booking",
      "description": "Easily book your Washim day trip online to secure your preferred date, itinerary, and transport. Booking in advance ensures a smooth, organized, and enjoyable day without last-minute hassles."
    },
    {
      "name": "Washim Scenic Day Trip",
      "description": "Experience the most scenic day trips around Washim, featuring rivers, hills, gardens, and cultural sites. Perfect for photography, nature lovers, and anyone seeking a visually stunning and refreshing outdoor experience."
    }
  ],
  "tableData": [
    ["- One Day Trip Near Washim", "- Washim Day Tour"],
    ["- Washim Local Sightseeing Trip", "- Washim Short Excursion"],
    ["- Affordable One Day Trip Washim", "- Washim Nearby Attractions Trip"],
    ["- Washim Weekend Day Trip", "- Washim Family Day Trip"],
    ["- Washim Nature Day Trip", "- Washim Riverside Trip"],
    ["- Washim Hill One Day Tour", "- Washim Excursion Packages"],
    ["- Washim One Day Outing", "- Washim Day Trip Booking"],
    ["- Washim Scenic Day Trip", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Perfect One Day Trip Near Washim",
    "WhyChoosedescription": "Woodland Escape Resort offers an ideal destination for a refreshing one day trip near Washim. Surrounded by lush greenery and serene landscapes, it provides the perfect combination of relaxation, outdoor activities, and scenic beauty for a memorable day out."
  },
  {
    "WhyChooseheading": "Tranquil Natural Environment",
    "WhyChoosedescription": "Nestled amidst dense trees, open lawns, and gentle streams, the resort gives visitors a peaceful retreat from city life. The sights and sounds of nature, along with fresh air and shaded areas, create a rejuvenating atmosphere for everyone."
  },
  {
    "WhyChooseheading": "Activities for Family and Friends",
    "WhyChoosedescription": "From leisurely nature walks and cycling to pond-side relaxation and light adventure activities, Woodland Escape Resort offers a variety of options to keep guests entertained. Both children and adults can enjoy a mix of recreation and relaxation throughout the day."
  },
  {
    "WhyChooseheading": "Comfortable Day-Use Facilities",
    "WhyChoosedescription": "The resort features spacious picnic zones, shaded sit-outs, and well-maintained rest areas, ensuring a comfortable day visit. Guests can enjoy meals, play games, or simply relax while experiencing the resort’s natural charm."
  },
  {
    "WhyChooseheading": "Delicious Meals and Refreshments",
    "WhyChoosedescription": "Savor freshly prepared local and multi-cuisine dishes, along with snacks and beverages. Woodland Escape Resort makes sure your day trip is not only fun but also filled with delightful culinary experiences."
  },
  {
    "WhyChooseheading": "Ideal for Family and Group Outings",
    "WhyChoosedescription": "Whether it’s a family outing, a friends’ gathering, or a small group day-trip, the resort provides a safe, spacious, and welcoming environment. Guests can bond, play games, and create lasting memories together."
  },
  {
    "WhyChooseheading": "Easily Accessible from Washim",
    "WhyChoosedescription": "Situated just a short drive from Washim, Woodland Escape Resort is convenient for a hassle-free one day trip. You can spend more time enjoying nature and activities, and less time traveling."
  }
]






















  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort for a one day trip near Washim?",
    answer: "Woodland Escape Resort is the perfect destination for a one day trip near Washim, offering lush green surroundings, peaceful open spaces, and a variety of recreational activities. It’s ideal for a relaxing day trip with family and friends."
  },
  {
    question: "How far is Woodland Escape Resort from Washim city?",
    answer: "The resort is conveniently located within driving distance from Washim, making it an easy and accessible destination for a short day trip or weekend outing."
  },
  {
    question: "What activities are available during a one day trip at Woodland Escape Resort?",
    answer: "Guests can enjoy outdoor games, nature walks, cycling, open lawns, picnic spots, and scenic relaxation areas. There’s something for everyone, from kids to adults."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and groups for a one day trip?",
    answer: "Yes! The resort is family-friendly and group-friendly, providing safe and spacious areas where everyone can enjoy a fun and peaceful day together."
  },
  {
    question: "Does the resort provide food and refreshments for one day trip guests?",
    answer: "Absolutely! Woodland Escape Resort offers freshly prepared meals, snacks, and beverages. One day trip packages can include lunch and refreshments for a hassle-free experience."
  },
  {
    question: "How can we book a one day trip at Woodland Escape Resort near Washim?",
    answer: "Booking is simple — you can call or WhatsApp our reservations team, or visit the official website. Advance booking is recommended, especially for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Sunil & Family, Washim",
    text: "Our one day trip at Woodland Escape Resort was fantastic! The surroundings were beautiful, the kids enjoyed the activities, and the food was great. Perfect day trip near Washim!"
  },
  {
    name: "Ms. Priya & Friends, Washim",
    text: "We had a wonderful day at Woodland Escape Resort! The place is peaceful, fun, and perfect for a short getaway from Washim. Highly recommended for families and friends."
  }
];




























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Day Trip Near Washim",
  "image": "https://woodlandescape.com/assets/images/washim-one-day-trip.jpg",
  "description": "Experience an exciting one-day trip near Washim at Woodlandescape Resort. Perfect for family outings, nature excursions, riverside adventures, and scenic hill visits.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "38"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/one-day-trip-washim"
  }
};



  return (
    <div>
<Helmet>
  <title>One Day Trip Near Washim | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a one-day trip near Washim at Woodlandescape Resort. Ideal for family outings, local sightseeing, nature excursions, riverside adventures, and scenic hill trips." 
  />
  <meta 
    name="keywords" 
    content="One Day Trip Near Washim, Washim Day Tour, Washim Local Sightseeing Trip, Washim Short Excursion, Affordable One Day Trip Washim, Washim Nearby Attractions Trip, Washim Weekend Day Trip, Washim Family Day Trip, Washim Nature Day Trip, Washim Riverside Trip, Washim Hill One Day Tour, Washim Excursion Packages, Washim One Day Outing, Washim Day Trip Booking, Washim Scenic Day Trip" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/41.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Onedaytripnearwashim;